import "./Portfolio.css";
import Pfp from "../../assets/ProfilePic.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";

function Portfolio() {
  return (
    <div className="firstdiv" id="home">
      <div className="subdiv1">
        <div className="dpic box">
          <img src={Pfp} alt="ProfilePic" />
        </div>
        <div className="box1"></div>

        <div className="dtext"></div>
      </div>
      <div className="subdiv2">
        <div>
          <span>
            <h1>Hi,</h1>
          </span>
          <span>
            <h2>
              I am <span className="name">Anjali Kumari Dubey</span>.
            </h2>
          </span>
          <span>Software Engineer | Bibliophile | Philomath</span>
        </div>
        <p>
          I am an Associate Software Engineer at Compro Technologies, I
          specialize in building and maintaining web applications using
          JavaScript technologies like VueJS, NodeJS, and ExpressJS. I have
          completed my Bachelor of Technology in Computer Science & Engineering
          from the Guru Gobind Singh Indraprastha University, graduating with a
          stellar CGPA of 9.69. During my academic journey, I honed my
          programming skills in C++, JavaScript, and Java, along with gaining
          experience in frameworks such as Bootstrap, NextJS, and databases like
          MongoDB and PostgreSQL. I’m passionate about solving complex
          challenges through efficient coding, contributing to open-source
          projects, and staying active in tech communities like GDG New Delhi
          and the WomenTech Network.
        </p>
        <br />
        <a
          href="https://akd-01-github-io.vercel.app/blog.html"
          className="mt-2 block blog-button"
          rel="noreferrer"
          target="_blank"
        >
          Go to My Blog{" "}
          <FontAwesomeIcon className="ml-2" icon={faCircleArrowRight} />{" "}
        </a>
        <br />
      </div>
    </div>
  );
}

export default Portfolio;
